/**
 * Created by AlexanderC on 6/15/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepKernel = require('deep-kernel');

var _deepKernel2 = _interopRequireDefault(_deepKernel);

var _ConsoleDriver = require('./Driver/ConsoleDriver');

var _KinesisDriver = require('./Driver/KinesisDriver');

var _BackendContext = require('./Context/BackendContext');

var _FrontendContext = require('./Context/FrontendContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Event manager
 */
let Event = exports.Event = function (_Kernel$ContainerAwar) {
  _inherits(Event, _Kernel$ContainerAwar);

  /**
   * @param {Object} drivers
   */
  function Event() {
    let drivers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Event);

    var _this = _possibleConstructorReturn(this, (Event.__proto__ || Object.getPrototypeOf(Event)).call(this));

    _this._driver = null;
    return _this;
  }

  /**
   * @returns {ConsoleDriver|KinesisDriver|*}
   */


  _createClass(Event, [{
    key: 'log',


    /**
     * @param {*} args
     *
     * @returns {Promise|*}
     */
    value: function log() {
      var _driver;

      return (_driver = this.driver).log.apply(_driver, arguments);
    }

    /**
     * @param {String} kinesisStreamArn
     *
     * @returns {Event|*}
     */

  }, {
    key: 'ensureKinesisDriver',
    value: function ensureKinesisDriver() {
      let kinesisStreamArn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this._driver && this._driver instanceof _KinesisDriver.KinesisDriver) {
        return this;
      }

      kinesisStreamArn = kinesisStreamArn || this.kernel.config.globals.kinesisEventStream;

      this._driver = new _KinesisDriver.KinesisDriver(kinesisStreamArn, this._driver.context);

      return this;
    }

    /**
     * Booting a certain service
     *
     * @param {Kernel} kernel
     * @param {Function} callback
     */

  }, {
    key: 'boot',
    value: function boot(kernel, callback) {
      const kinesisStreamArn = kernel.config.globals.kinesisEventStream;
      const context = (kernel.isFrontend ? _FrontendContext.FrontendContext : _BackendContext.BackendContext).fromKernel(kernel);

      if (kernel.env !== _deepKernel2.default.PROD_ENVIRONMENT || !kinesisStreamArn) {
        this._driver = new _ConsoleDriver.ConsoleDriver(context);
      } else {
        this._driver = new _KinesisDriver.KinesisDriver(kinesisStreamArn, context);
      }

      callback();
    }
  }, {
    key: 'driver',
    get: function get() {
      return this._driver;
    }
  }]);

  return Event;
}(_deepKernel2.default.ContainerAware);


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/Event.js
// module id = 386
// module chunks = 0